import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class RestcommNumbers extends ConsoleApi {
    protected resource = '/restcomm/incoming_phone_numbers';

    /**
     * @param accountId
     * @param incomingPhoneNumberSid
     */
    public find(accountId: string, incomingPhoneNumberSid: string): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/' + incomingPhoneNumberSid, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param query
     */
    public get(accountId: string, query: string | null = null): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + query, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param applicationName
     * @param referenceRcmlUrl
     */
    public create(accountId: string, applicationName: string, referenceRcmlUrl: string): Promise<AxiosResponse> {
        return this.axios.post(this.requestUri + this.getAccountResource(accountId), {
            'FriendlyName': applicationName,
            'RcmlUrl': referenceRcmlUrl,
        }, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param incomingPhoneNumber
     */
    public apply(accountId: string, incomingPhoneNumber: string): Promise<AxiosResponse> {
        return this.axios.post(this.requestUri + this.getAccountResource(accountId) + "/apply", {
            'PhoneNumber': incomingPhoneNumber,
        }, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param incomingPhoneNumberSid
     * @param voiceUrl
     * @param voiceMethod
     * @param statusCallBack
     * @param statusCallBackMethod
     * @param voiceFallBackUrl
     * @param voiceFallBackMethod
     * @param voiceApplicationSid
     */
    public update(accountId: string,
                  incomingPhoneNumberSid: string,
                  voiceUrl: string | null,
                  voiceMethod: string | null,
                  statusCallBack: string | null,
                  statusCallBackMethod: string | null,
                  voiceFallBackUrl: string | null,
                  voiceFallBackMethod: string | null,
                  voiceApplicationSid: string | null
    ): Promise<AxiosResponse> {
        return this.axios.put(this.requestUri + this.getAccountResource(accountId) + '/' + incomingPhoneNumberSid, {
            voiceUrl: voiceUrl,
            voiceMethod: voiceMethod,
            statusCallBack: statusCallBack,
            statusCallBackMethod: statusCallBackMethod,
            voiceFallBackUrl: voiceFallBackUrl,
            voiceFallBackMethod: voiceFallBackMethod,
            voiceApplicationSid: voiceApplicationSid,
        }, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param incomingPhoneNumberSid
     */
    public delete(accountId: string, incomingPhoneNumberSid: string): Promise<AxiosResponse> {
        return this.axios.delete(this.requestUri + this.getAccountResource(accountId) + '/' + incomingPhoneNumberSid, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}